import { Box, Th, Tooltip } from '@chakra-ui/react'
import React from 'react'
import { useInteractiveTableHeaderCellStyles } from 'hooks/useInteractiveTableHeaderCellStyles'

type InteractiveHeaderCellProps = {
  /**
   * @description Text to be displayed when hovering over the cell
   */
  tooltipText?: string
} & Omit<React.ComponentProps<typeof Box>, 'sx'>

export const InteractiveHeaderCell = ({
  tooltipText,
  children,
  ...props
}: InteractiveHeaderCellProps) => {
  const styles = useInteractiveTableHeaderCellStyles()

  return tooltipText ? (
    <Th>
      <Tooltip label={tooltipText}>
        <Box as="span" w="fit-content" sx={styles} {...props}>
          {children}
        </Box>
      </Tooltip>
    </Th>
  ) : (
    <Th>
      <Box as="span" w="fit-content" sx={styles} {...props}>
        {children}
      </Box>
    </Th>
  )
}
